var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"32dc3767813a234f84f902d488b6e06477798d50"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["supabase-app-staging@supabase"]={id:"32dc3767813a234f84f902d488b6e06477798d50"};
      